(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var tactil = window.matchMedia('(hover: none)').matches;

  // Un solo IntersectionObserver para todo lo que aparece al hacer scroll
  var observador = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('mt-visible');
        observador.unobserve(e.target);
      }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' }) : null;

  function initReveals(raiz) {
    raiz.querySelectorAll('.mt-reveal, [data-mt-observar]').forEach(function (el) {
      if (el.dataset.mtInit) return;
      el.dataset.mtInit = '1';
      if (!observador || reducido) { el.classList.add('mt-visible'); return; }
      observador.observe(el);
    });
  }

  // Héroe: foco que sigue al cursor + inclinación suave del producto
  function initHero(raiz) {
    raiz.querySelectorAll('[data-mt-hero]').forEach(function (hero) {
      if (hero.dataset.mtHeroInit) return;
      hero.dataset.mtHeroInit = '1';
      if (reducido || tactil) return;
      var envoltorio = hero.closest('.shopify-section') || hero;
      var tilt = hero.querySelector('.mt-hero__tilt');
      var maxGrados = parseFloat(hero.dataset.inclinacion || '6');
      var pendiente = false, ultimo = null;
      envoltorio.addEventListener('mousemove', function (ev) {
        ultimo = ev;
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () {
          pendiente = false;
          var r = envoltorio.getBoundingClientRect();
          var x = (ultimo.clientX - r.left) / r.width;
          var y = (ultimo.clientY - r.top) / r.height;
          hero.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
          hero.style.setProperty('--my', (y * 100).toFixed(1) + '%');
          if (tilt) tilt.style.transform = 'perspective(900px) rotateY(' + ((x - 0.5) * maxGrados * 2).toFixed(2) + 'deg) rotateX(' + ((0.5 - y) * maxGrados * 2).toFixed(2) + 'deg)';
        });
      });
      envoltorio.addEventListener('mouseleave', function () {
        if (tilt) tilt.style.transform = '';
      });
    });
  }

  // Escena sticky: el párrafo visible activa su imagen
  function initHistoria(raiz) {
    raiz.querySelectorAll('[data-mt-historia]').forEach(function (bloque) {
      if (bloque.dataset.mtInit) return;
      bloque.dataset.mtInit = '1';
      var pasos = bloque.querySelectorAll('.mt-hist__paso');
      var imgs = bloque.querySelectorAll('.mt-hist__media img');
      if (!pasos.length) return;
      function activar(i) {
        pasos.forEach(function (p, j) { p.classList.toggle('mt-activo', j === i); });
        imgs.forEach(function (img, j) { img.classList.toggle('mt-activa', j === i); });
      }
      activar(0);
      if (!('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) activar(Array.prototype.indexOf.call(pasos, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      pasos.forEach(function (p) { obs.observe(p); });
    });
  }

  // Botones magnéticos (#88)
  function initMagneticos(raiz) {
    if (reducido || tactil) return;
    raiz.querySelectorAll('[data-mt-magnetico]').forEach(function (btn) {
      if (btn.dataset.mtMagInit) return;
      btn.dataset.mtMagInit = '1';
      btn.addEventListener('mousemove', function (ev) {
        var r = btn.getBoundingClientRect();
        var dx = (ev.clientX - (r.left + r.width / 2)) / r.width;
        var dy = (ev.clientY - (r.top + r.height / 2)) / r.height;
        btn.style.transform = 'translate(' + (dx * 8).toFixed(1) + 'px,' + (dy * 6).toFixed(1) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  // Página de producto: galería + variantes
  function initProducto(raiz) {
    raiz.querySelectorAll('[data-mt-producto]').forEach(function (prod) {
      if (prod.dataset.mtInit) return;
      prod.dataset.mtInit = '1';
      var principal = prod.querySelector('.mt-prod__principal img');
      var minis = prod.querySelectorAll('.mt-prod__mini');
      function mostrar(src, srcset, alt) {
        if (!principal || !src) return;
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = src;
          if (srcset) principal.srcset = srcset;
          principal.alt = alt || '';
          principal.style.opacity = '1';
        }, 180);
      }
      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          minis.forEach(function (x) { x.classList.remove('mt-activa'); });
          m.classList.add('mt-activa');
          mostrar(m.dataset.src, m.dataset.srcset, m.dataset.alt);
        });
      });

      var datos = prod.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes = [];
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      var inputId = prod.querySelector('input[name="id"]');
      var precio = prod.querySelector('[data-mt-precio]');
      var tachado = prod.querySelector('[data-mt-tachado]');
      var boton = prod.querySelector('.mt-prod__comprar');
      var aviso = prod.querySelector('.mt-prod__agotado');
      var formato = prod.dataset.formato || '${{amount}}';
      function dinero(cents) {
        var v = (cents / 100).toFixed(2);
        return formato.replace(/\{\{\s*amount[^}]*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
      }
      prod.querySelectorAll('.mt-prod__opcion input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var elegidas = [];
          prod.querySelectorAll('.mt-prod__opcion').forEach(function (fs) {
            var marcado = fs.querySelector('input:checked');
            elegidas.push(marcado ? marcado.value : null);
          });
          var v = variantes.find(function (x) {
            return x.options.every(function (o, i) { return o === elegidas[i]; });
          });
          if (!v) {
            if (boton) boton.disabled = true;
            if (aviso) aviso.textContent = prod.dataset.textoNoDisponible || 'Unavailable';
            return;
          }
          if (inputId) inputId.value = v.id;
          if (precio) precio.textContent = dinero(v.price);
          if (tachado) {
            tachado.textContent = v.compare_at_price && v.compare_at_price > v.price ? dinero(v.compare_at_price) : '';
          }
          if (boton) {
            boton.disabled = !v.available;
            var t = boton.querySelector('[data-mt-boton-texto]');
            if (t) t.textContent = v.available ? boton.dataset.textoComprar : boton.dataset.textoAgotado;
          }
          if (aviso) aviso.textContent = '';
          if (v.featured_media && v.featured_media.preview_image) {
            mostrar(v.featured_media.preview_image.src, '', v.featured_media.alt);
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    });
  }

  function initTodo(ev) {
    var raiz = (ev && ev.target && ev.target.querySelectorAll) ? ev.target : document;
    initReveals(raiz);
    initHero(raiz);
    initHistoria(raiz);
    initMagneticos(raiz);
    initProducto(raiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  } else {
    initTodo();
  }
  document.addEventListener('shopify:section:load', initTodo);
})();
